import { validators, z } from '@frontend/forms';
import { useEffect, useState, useVisibilityController } from '@frontend/react';
import { FlatList, Header, PageContainer, Text, YStack } from '@frontend/web-react';
import { LetterRecommendationCard } from '@frontend/web/components';
import LetterRecommendationDetailModal from '@frontend/web/components/DomainSpecific/LetterRecommendations/LetterRecommendationDetailModal';
import { useListLetterRecommendationsQuery } from '@frontend/web/hooks';
import { createFileRoute, useRouter } from '@tanstack/react-router';

const LetterRecommendation = () => {
  const router = useRouter();
  const search = Route.useSearch();
  const { data: letterRecommendations, isLoading: isLetterRecommendationsLoading } =
    useListLetterRecommendationsQuery();
  const [
    isLetterRecommendationDetailModalOpen,
    { close: closeLetterRecommendationDetailModal, open: openLetterRecommendationDetailModal },
  ] = useVisibilityController();
  const [selectedLetterRecommendationId, setSelectedLetterRecommendationId] = useState<string | null>(null);

  useEffect(() => {
    if (search.letterRecommendationId) {
      handleLetterRecommendationSelect(search.letterRecommendationId);
    }
  }, []);

  const handleLetterRecommendationSelect = (id: string) => {
    setSelectedLetterRecommendationId(id);
    openLetterRecommendationDetailModal();
  };

  const handleCloseDetailModal = () => {
    setSelectedLetterRecommendationId(null);
    closeLetterRecommendationDetailModal();
  };

  return (
    <PageContainer
      HeaderComponent={<Header isLoading={isLetterRecommendationsLoading} onClickBack={router.history.back} title="" />}
      isLoading={isLetterRecommendationsLoading}
      isScrollable
      padding="none"
    >
      <YStack className="gap-sm px-md">
        <Text type="h4">{"Bill's"} weekly picks</Text>
        <FlatList
          contentContainerClassName="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3"
          data={letterRecommendations}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => (
            <LetterRecommendationCard
              letterRecommendation={item}
              onPress={() => handleLetterRecommendationSelect(item.id)}
            />
          )}
        />
      </YStack>
      {selectedLetterRecommendationId ? (
        <LetterRecommendationDetailModal
          isOpen={!!selectedLetterRecommendationId && isLetterRecommendationDetailModalOpen}
          letterRecommendationId={selectedLetterRecommendationId}
          onClose={handleCloseDetailModal}
        />
      ) : null}
    </PageContainer>
  );
};

export const Route = createFileRoute('/app/letter-recommendation/')({
  component: LetterRecommendation,
  validateSearch: (search) =>
    z
      .object({
        letterRecommendationId: validators.uuid().optional(),
      })
      .parse(search),
});
